export const FETCH_KEYWORDS_REQUEST = 'FETCH_KEYWORDS_REQUEST';
export const FETCH_KEYWORDS_SUCCESS = 'FETCH_KEYWORDS_SUCCESS';
export const FETCH_KEYWORDS_FAILURE = 'FETCH_KEYWORDS_FAILURE';
export const RESET_KEYWORDS = 'RESET_KEYWORDS';
